import { orchestrator } from 'satcheljs';
import { refreshImmutableSelectedCalendars } from 'owa-calendar-module-selected-calendars-user-config';
import { restoreSelectedCalendars } from '../actions/restoreSelectedCalendars';

// this should only run on time for each user on their first load into the fwk-immutable-ids flight
orchestrator(refreshImmutableSelectedCalendars, actionMessage => {
    restoreSelectedCalendars(actionMessage.userIdentity);
});
